import { render, staticRenderFns } from "./OscarSubProject.vue?vue&type=template&id=0dd9437c&scoped=true"
import script from "./OscarSubProject.vue?vue&type=script&lang=js"
export * from "./OscarSubProject.vue?vue&type=script&lang=js"
import style0 from "./OscarSubProject.vue?vue&type=style&index=0&id=0dd9437c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd9437c",
  null
  
)

export default component.exports